
const fade = (delay = 0.2) => {
    return {
        hidden: {
            opacity: 0,
        },
        visible: {
            opacity: 1,
            transition: {
                delay,
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.22
            }
        },
    }
};

export default fade;